/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * DevelopmentCenterParticipantApi - axios parameter creator
 * @export
 */
export const DevelopmentCenterParticipantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zwraca plik PDF raportu Development Center zalogowanego uczestnika w tej certyfikacji. Pracownik pobiera wyłącznie swój raport - identyfikatora nie ma w adresie, bierze się go z sesji.  Raporty są dostępne dopiero od daty ustawionej przez administratora na etapie DC. Przed tą datą - a także gdy data w ogóle nie została ustawiona - odpowiedzią jest 403. Sytuacja \"raport jeszcze nie wgrany\" to 404, żeby dało się ją odróżnić od odmowy z powodu daty.
         * @summary Pobierz własny raport Development Center
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOwnDevelopmentCenterReport: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('downloadOwnDevelopmentCenterReport', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/my-report`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevelopmentCenterParticipantApi - functional programming interface
 * @export
 */
export const DevelopmentCenterParticipantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevelopmentCenterParticipantApiAxiosParamCreator(configuration)
    return {
        /**
         * Zwraca plik PDF raportu Development Center zalogowanego uczestnika w tej certyfikacji. Pracownik pobiera wyłącznie swój raport - identyfikatora nie ma w adresie, bierze się go z sesji.  Raporty są dostępne dopiero od daty ustawionej przez administratora na etapie DC. Przed tą datą - a także gdy data w ogóle nie została ustawiona - odpowiedzią jest 403. Sytuacja \"raport jeszcze nie wgrany\" to 404, żeby dało się ją odróżnić od odmowy z powodu daty.
         * @summary Pobierz własny raport Development Center
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOwnDevelopmentCenterReport(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOwnDevelopmentCenterReport(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterParticipantApi.downloadOwnDevelopmentCenterReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevelopmentCenterParticipantApi - factory interface
 * @export
 */
export const DevelopmentCenterParticipantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevelopmentCenterParticipantApiFp(configuration)
    return {
        /**
         * Zwraca plik PDF raportu Development Center zalogowanego uczestnika w tej certyfikacji. Pracownik pobiera wyłącznie swój raport - identyfikatora nie ma w adresie, bierze się go z sesji.  Raporty są dostępne dopiero od daty ustawionej przez administratora na etapie DC. Przed tą datą - a także gdy data w ogóle nie została ustawiona - odpowiedzią jest 403. Sytuacja \"raport jeszcze nie wgrany\" to 404, żeby dało się ją odróżnić od odmowy z powodu daty.
         * @summary Pobierz własny raport Development Center
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOwnDevelopmentCenterReport(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadOwnDevelopmentCenterReport(certificationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevelopmentCenterParticipantApi - interface
 * @export
 * @interface DevelopmentCenterParticipantApi
 */
export interface DevelopmentCenterParticipantApiInterface {
    /**
     * Zwraca plik PDF raportu Development Center zalogowanego uczestnika w tej certyfikacji. Pracownik pobiera wyłącznie swój raport - identyfikatora nie ma w adresie, bierze się go z sesji.  Raporty są dostępne dopiero od daty ustawionej przez administratora na etapie DC. Przed tą datą - a także gdy data w ogóle nie została ustawiona - odpowiedzią jest 403. Sytuacja \"raport jeszcze nie wgrany\" to 404, żeby dało się ją odróżnić od odmowy z powodu daty.
     * @summary Pobierz własny raport Development Center
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterParticipantApiInterface
     */
    downloadOwnDevelopmentCenterReport(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

}

/**
 * DevelopmentCenterParticipantApi - object-oriented interface
 * @export
 * @class DevelopmentCenterParticipantApi
 * @extends {BaseAPI}
 */
export class DevelopmentCenterParticipantApi extends BaseAPI implements DevelopmentCenterParticipantApiInterface {
    /**
     * Zwraca plik PDF raportu Development Center zalogowanego uczestnika w tej certyfikacji. Pracownik pobiera wyłącznie swój raport - identyfikatora nie ma w adresie, bierze się go z sesji.  Raporty są dostępne dopiero od daty ustawionej przez administratora na etapie DC. Przed tą datą - a także gdy data w ogóle nie została ustawiona - odpowiedzią jest 403. Sytuacja \"raport jeszcze nie wgrany\" to 404, żeby dało się ją odróżnić od odmowy z powodu daty.
     * @summary Pobierz własny raport Development Center
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterParticipantApi
     */
    public downloadOwnDevelopmentCenterReport(certificationId: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterParticipantApiFp(this.configuration).downloadOwnDevelopmentCenterReport(certificationId, options).then((request) => request(this.axios, this.basePath));
    }
}

